import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { useNavigationMenuItems } from 'hooks/useNavigationMenuItems';

const NavigationMenuContext = createContext(null);

export function NavigationMenuProvider({ children }) {
  const value = useNavigationMenuItems();
  return (
    <NavigationMenuContext.Provider value={value}>{children}</NavigationMenuContext.Provider>
  );
}

NavigationMenuProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// For a component that can also render outside the app layout (and then simply shows less).
export function useOptionalNavigationMenu() {
  return useContext(NavigationMenuContext);
}

export function useNavigationMenu() {
  const context = useContext(NavigationMenuContext);
  if (!context) {
    throw new Error('useNavigationMenu must be used within NavigationMenuProvider');
  }
  return context;
}
